import {
  EMPLOYER_PRODUCT_PRICING_LIST_LOADING,
  EMPLOYER_PRODUCT_PRICING_LIST_UPDATED,
  EMPLOYER_PRODUCT_PRICING_ERROR,
  EMPLOYER_PRODUCT_PRICING_RESET,
  EMPLOYER_PRODUCT_PRICING_PARAMS_UPDATE,
} from "actions/types";

const initialState = {
  pricingList: {
    data: [],
    count: 0,
    page: 1,
  },
  sortingParams: {
    limit: 10,
    page: 1,
    orderBy: "createdAt",
    ascending: "desc",
  },
  loadingListData: false,
  error: {},
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYER_PRODUCT_PRICING_RESET:
      return initialState;
    case EMPLOYER_PRODUCT_PRICING_LIST_LOADING:
      return { ...state, loadingListData: true };
    case EMPLOYER_PRODUCT_PRICING_PARAMS_UPDATE:
      return { ...state, sortingParams: { ...state.sortingParams, ...payload } };
    case EMPLOYER_PRODUCT_PRICING_LIST_UPDATED:
      return {
        ...state,
        pricingList: {
          data: payload.data || [],
          count: payload.metadata?.[0]?.totalRecord || 0,
          page: payload.metadata?.[0]?.current_page || 1,
        },
        loadingListData: false,
      };
    case EMPLOYER_PRODUCT_PRICING_ERROR:
      return { ...state, error: payload, loadingListData: false };
    default:
      return state;
  }
}
